import { formatMoneyAmount } from '@nemuru-eng/js-api-client';

import { EditDownPaymentProps } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionDownPaymentDialog/components/EditDownPayment';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

export const EditDownPaymentOldValues = ({ checkoutSession }: Pick<EditDownPaymentProps, 'checkoutSession'>) => {
  const { sm } = useScreen();
  const { palette } = useCustomTheme();

  return (
    <FlexColumn gridGap={20} alignItems={'flex-start'} width={'100%'}>
      <FlexRow gridGap={8} justifyContent="flex-start">
        {true && (
          <Icon size={sm ? 24 : 24} color={palette.info.main}>
            info
          </Icon>
        )}
        <Font style={{ color: palette.info.main }} variant="h5">
          <strong>
            <Text tId={'OLD_VALUES'} />
          </strong>
        </Font>
      </FlexRow>
      <FlexRow justifyContent={'space-between'} alignItems={'flex-start'} width={'100%'}>
        <FlexColumn gridGap={12} alignItems={'flex-start'}>
          <Font color="textPrimary" variant="caption">
            <strong>
              <Text tId={'TOTAL_TO_FINANCE'} />
            </strong>
            {': '} {formatMoneyAmount(checkoutSession.totalPrice)}
          </Font>
          <Font color="textPrimary" variant="caption">
            <strong>
              <Text tId={'DOWN_PAYMENT'} />
            </strong>
            {': '} {formatMoneyAmount(checkoutSession.downPayment?.amount)}
          </Font>
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  );
};
